import { render, staticRenderFns } from "./AccountSettingsPage.vue?vue&type=template&id=28aa1b43&"
import script from "./AccountSettingsPage.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports